import type { SurveyCustomAction } from 'autogen/swagger/all';
import { forwardRef } from 'react';
import type { CustomActionProps } from '../CustomAction';
import { CustomActionButton } from '../shared/styles';
import { useOpenSurveyQuickView } from 'components/surveySystem/shared/hooks/useOpenSurveyQuickView';

type SurveyActionProps = { action: SurveyCustomAction } & CustomActionProps;

const SurveyAction = forwardRef<HTMLButtonElement, SurveyActionProps>(({ action, onClick, ...restProps }, ref) => {
    const { openSurveyQuickViewBySurveyId } = useOpenSurveyQuickView();

    return (
        <CustomActionButton
            ref={ref}
            type="button"
            onClick={(e) => {
                if (onClick) {
                    onClick(e);
                }
                openSurveyQuickViewBySurveyId({ surveyId: action.surveyId, returnUrl: window.location.href });
            }}
            {...restProps}
        />
    );
});

export default SurveyAction;
